import { render, staticRenderFns } from "./cargo-correction-details.vue?vue&type=template&id=36feed00&scoped=true"
import script from "./cargo-correction-details.vue?vue&type=script&lang=js"
export * from "./cargo-correction-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36feed00",
  null
  
)

export default component.exports